import { useGetAllCourtsQuery } from '@/store/apis/hosted-filters-api'
import { useMemo } from 'react'
import { getTopLevelFederalCourts, getCircuitBasedFederalCourts } from '../jurisdiction-sources/federal-jurisdictions-mappings'

/**
 * Hook to fetch and process federal courts data
 * Uses RTK Query to lazy-load data from /public instead of bundling it
 *
 * @returns Object containing federal court options and loading/error states
 */
export function useFederalCourtsData() {
  const { data, isLoading, isError } = useGetAllCourtsQuery()

  const topLevelFederalCourts = useMemo(() => {
    if (!data) return []
    return getTopLevelFederalCourts(data)
  }, [data])

  const circuitBasedFederalCourts = useMemo(() => {
    if (!data) return []
    return getCircuitBasedFederalCourts(data)
  }, [data])

  return {
    topLevelFederalCourts,
    circuitBasedFederalCourts,
    isLoading,
    isError,
  }
}
